import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import TaskSkeleton from "./TaskSkeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faFilePdf, faFileExcel, faPrint } from "@fortawesome/free-solid-svg-icons";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

export default function Dashboard() {
  const { http, user } = AuthUser();
  const [searchParams] = useSearchParams();
  const [tasks, setTasks] = useState([]);
  const [TaskCount, setTaskCount] = useState();
  const [date, setDate] = useState(null);
  const [remark, setRemark] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [departments, setdepartments] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [loginUser, setloginUser] = useState(user.department_id);
  const [loginUserId, setloginUserId] = useState(user.id);
  const [selectedDepartmentId, setselectedDepartmentId] = useState("");
  const [selectedUser, setselectedUser] = useState("");
  const [selectedAssignedBy, setSelectedAssignedBy] = useState(
    searchParams.get("assigned_by") || ""
  );
  const [selectedStatus, setsselectedStatus] = useState(
    searchParams.get("status") || "Pending"
  );
  const [startDate, setstartDate] = useState(searchParams.get("startdate") || "");
  const [endDate, setendDate] = useState(searchParams.get("enddate") || "");
  const [userss, setUserss] = useState([]);
  const [assigners, setAssigners] = useState([]);

  useEffect(() => {
    http.get(`/department_user_company?login_user=${user.id}`).then((res) => {
      setAssigners(res.data.users || []);
    });
  }, [user.id]);

  useEffect(() => {
    http.get(`/department_user_company_baseuser?dept=${selectedDepartmentId}&login_user=${user.id}`).then((res) => {
      setUserss(res.data.users);
    });

    fetchTaskDetails(
      selectedDepartmentId,
      selectedStatus,
      startDate,
      endDate,
      selectedUser,
      selectedAssignedBy
    );
  }, [selectedDepartmentId, selectedStatus, startDate, endDate, selectedUser, selectedAssignedBy]);

  const fetchTaskDetails = (
    seldepartment = "",
    selstatus = "",
    startDate = "",
    endDate = "",
    seluser = "",
    assignedBy = ""
  ) => {
    setIsLoading(true);
    let endpoint;
    if (user && user.department_id === 1) {
      endpoint = `/tasks?department=${seldepartment}&status=${selstatus}&login_user=${user.id}&startdate=${startDate}&enddate=${endDate}&seluser=${seluser}&assigned_by=${assignedBy}`;
    } else if (user) {
      endpoint = `/tasks?user=${user.id}&department=${seldepartment}&status=${selstatus}&login_user=${user.id}&startdate=${startDate}&enddate=${endDate}&seluser=${seluser}&assigned_by=${assignedBy}`;
    } else {
      setIsLoading(false);
      console.error("User is not defined or authenticated");
      return;
    }

    http
      .get(endpoint)
      .then((res) => {
        setIsLoading(false);
        if (Array.isArray(res.data.data)) {
          setTasks(res.data.data);
          setTaskCount(res.data.data.length);
        } else {
          console.error("API response is not an array");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching tasks:", error);
      });

    http.get(`/departments?login_user=${user.id}`).then((res) => {
      setdepartments(res.data.data);
    });
  };
  const [showModal, setShowModal] = useState(false);
  const [showModalRevise, setShowModalRevise] = useState(false);
  const [ModalId, setModalId] = useState(false);
  const openModal = (taskId) => {
    setShowModal(true);
    setModalId(taskId);
  };

  const openModalRevise = (rmark, revisedate) => {
    setDate(revisedate);
    setRemark(rmark);
    setShowModalRevise(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setShowModalRevise(false);
  };
  const handleChange = async (event) => {
    setselectedDepartmentId(event.target.value);
  };

  const handleChangeUser = async (event) => {
    setselectedUser(event.target.value);
  };

  const handleChangeAssignedBy = async (event) => {
    setSelectedAssignedBy(event.target.value);
  };

  const rowData = (t, i) => ({
    No: i + 1,
    Id: `T${t.id}`,
    "Created On": t.created_at ? moment(t.created_at).format("DD MMM,YY") : "-",
    Description: [
      t.jc_id ? `JC-${t.jc_id}` : "",
      t.amc_id ? `AC-${t.amc_id}` : "",
      t.description || "",
      t.customer_name || "",
    ]
      .filter(Boolean)
      .join(" "),
    "Assign To": t.assignee
      ? `${t.assignee.name || ""} ${t.assignee.last_name || ""}`.trim()
      : "-",
    Department: t.department?.name || "-",
    Status: t.status || "-",
    "Due Date": t.target_date ? moment(t.target_date).format("DD MMM,YY") : "-",
    W: t.task_weightage ?? "-",
    ...(user?.company_id === 1 ? { EH: t.est_time ?? "-" } : {}),
    Priority: t.priority || "-",
    "Assign By": t.assigner
      ? `${t.assigner.name || ""} ${t.assigner.last_name || ""}`.trim()
      : "-",
  });

  const exportPDF = () => {
    if (!tasks.length) {
      toast.error("No tasks to export");
      return;
    }
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(14);
    doc.setTextColor(13, 110, 253);
    doc.text(
      user?.department_id === 1 ? "All Tasks List" : "Your Tasks List",
      14,
      15
    );
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text(
      `Generated: ${moment().format("DD MMM YYYY, hh:mm A")}  |  Records: ${tasks.length}`,
      14,
      22
    );
    const rows = tasks.map((t, i) => rowData(t, i));
    const head = [Object.keys(rows[0])];
    const body = rows.map((r) => Object.values(r));
    autoTable(doc, {
      startY: 27,
      head,
      body,
      styles: { fontSize: 7, cellPadding: 2 },
      headStyles: { fillColor: [13, 110, 253], textColor: 255, fontStyle: "bold" },
      alternateRowStyles: { fillColor: [245, 245, 245] },
    });
    doc.save(`tasks_dashboard_${moment().format("YYYYMMDD_HHmm")}.pdf`);
  };

  const exportExcel = () => {
    if (!tasks.length) {
      toast.error("No tasks to export");
      return;
    }
    const rows = tasks.map((t, i) => rowData(t, i));
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Tasks");
    XLSX.writeFile(wb, `tasks_dashboard_${moment().format("YYYYMMDD_HHmm")}.xlsx`);
  };

  const exportCSV = () => {
    if (!tasks.length) {
      toast.error("No tasks to export");
      return;
    }
    const rows = tasks.map((t, i) => rowData(t, i));
    const headers = Object.keys(rows[0]);
    const escape = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
    const csv = [
      headers.map(escape).join(","),
      ...rows.map((r) => headers.map((h) => escape(r[h])).join(",")),
    ].join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `tasks_dashboard_${moment().format("YYYYMMDD_HHmm")}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const handlePrint = () => {
    if (!tasks.length) {
      toast.error("No tasks to print");
      return;
    }
    window.print();
  };

  const handleChangeType = async (event) => {
    setsselectedStatus(event.target.value);
  };

  const handleChangeStartDate = async (event) => {
    setstartDate(event.target.value);
  };

  const handleChangeEndDate = async (event) => {
    setendDate(event.target.value);
  };

  const statusUpdate = (e) => {
    setCurrentStatus(e.target.value);
  };

  const deleteTask = async (taskId) => {
    await http
      .delete(`/tasks/${taskId}`)
      .then((response) => {
        toast.success("Task Deleted successfully !");
        // setTasks(response.data.data);
        fetchTaskDetails(selectedDepartmentId, selectedStatus, startDate, endDate, selectedUser, selectedAssignedBy);
      })
      .catch((err) => {
        console.error("Error deleting task", err);
      });
  };

  const handleSave = async (taskId) => {
    if (currentStatus === null || taskId === null) {
      toast.error("Please select proper status");
      return true;
    }
    try {
      const response = await http.put(
        `task_status_update?task_id=${taskId}&status=${encodeURIComponent(
          currentStatus
        )}`
      );
      toast.success("Task status updated successfully !");
      fetchTaskDetails(selectedDepartmentId, selectedStatus, startDate, endDate, selectedUser, selectedAssignedBy);
    } catch (error) {
      console.error("Error fetching tasks:", error);
      toast.error("Please select proper item");
    }
  };

  const [formData, setFormData] = useState({
    revised_date: "",
    revised_remark: "",
  });
  const initialState = {
    revised_date: "",
    revised_remark: "",
  };

  const handleChangeModal = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.revised_remark || !formData.revised_date) {
      toast.error("Please fill in both Revised Remark and New Revision Date.");
      return;
    }
    try {
      http.put(`/revise/${ModalId}`, formData).then((res) => {
        toast.success("revise date added successfully !");
        setFormData(initialState);
        fetchTaskDetails(selectedDepartmentId, selectedStatus, startDate, endDate, selectedUser, selectedAssignedBy);
        closeModal();
      });
    } catch (error) {
      console.error("Error adding task:", error.response.data);
    }
  };

  const downloadFile = (filename) => {
    // Construct the URL to the file.
    const fileUrl = `http://3.6.125.26/api/storage/tasks/${filename}`;

    // Create a link element
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", ""); // the download attribute can be empty
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Remove the link from the DOM
  };
  function getRandomLightColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  const backgroundColorMap = new Map();

  // Function to get a unique background color for a user.id
  function getUniqueBackgroundColor(userId) {
    if (!backgroundColorMap.has(userId)) {
      // If the user.id doesn't have a background color assigned, generate one and store it in the map
      backgroundColorMap.set(userId, getRandomLightColor());
    }
    return backgroundColorMap.get(userId);
  }


  return (
    <>
      <Toaster />

      {showModal && (
        <form onSubmit={handleSubmit}>
          <div className="modal" tabindex="-1" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Revision Details</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeModal}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="form-group  mt-3">
                    <label>New Revision Date</label>
                    <input
                      name="revised_date"
                      className="form-control"
                      type="date"
                      onChange={handleChangeModal}
                    />
                  </div>

                  <div className="form-group mt-3">
                    <label>Revision Note</label>
                    <textarea
                      name="revised_remark"
                      className="form-control"
                      onChange={handleChangeModal}
                      rows="3"
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}

      {showModalRevise && (
        <div className="modal" tabindex="-1" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Revision Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="form-group  mt-3">
                  <label>New Revision Date</label>
                  <input
                    name="revised_date"
                    className="form-control"
                    type="date"
                    value={date}
                  />
                </div>

                <div className="form-group mt-3">
                  <label>Revision Note</label>
                  <textarea
                    name="revised_remark"
                    className="form-control"
                    rows="3"
                    value={remark}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="container mt-1">
        <div className="d-flex flex-nowrap align-items-end gap-2 mb-2 no-print" style={{ overflowX: "auto" }}>
          <div className="flex-shrink-0">
            {user && user.department_id == 1 ? (
              <h1 className="mb-0" style={{ fontSize: "1.15rem", whiteSpace: "nowrap" }}>
                All Tasks List ({TaskCount})
              </h1>
            ) : (
              <h1 className="mb-0" style={{ fontSize: "1.15rem", whiteSpace: "nowrap" }}>
                Your Tasks List ({TaskCount})
              </h1>
            )}
            <div className="d-flex gap-1 mt-1">
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={handlePrint}
                disabled={!tasks.length}
                title="Print filtered list"
              >
                <FontAwesomeIcon icon={faPrint} className="me-1" /> Print
              </button>
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={exportPDF}
                disabled={!tasks.length}
                title="Export PDF"
              >
                <FontAwesomeIcon icon={faFilePdf} className="me-1" /> PDF
              </button>
              <button
                type="button"
                className="btn btn-sm btn-success"
                onClick={exportExcel}
                disabled={!tasks.length}
                title="Export Excel"
              >
                <FontAwesomeIcon icon={faFileExcel} className="me-1" /> Excel
              </button>
              <button
                type="button"
                className="btn btn-sm btn-outline-success"
                onClick={exportCSV}
                disabled={!tasks.length}
                title="Export CSV"
              >
                CSV
              </button>
            </div>
          </div>

          {user && user.department_id == 1 && (
            <div className="flex-shrink-0" style={{ minWidth: "150px" }}>
              <select onChange={handleChange} className="form-control form-control-sm">
                <option value="">Select Department</option>
                <option value="">All Department</option>
                {departments.map((depart) => (
                  <option key={depart.id} value={depart.id}>
                    {depart.name}
                  </option>
                ))}
              </select>
            </div>
          )}

          {user && user.department_id == 1 && (
            <div className="flex-shrink-0" style={{ minWidth: "150px" }}>
              <select
                className="form-control form-control-sm text-uppercase"
                onChange={handleChangeUser}
                value={selectedUser}
              >
                <option value="">Select a user</option>
                {userss.map((u) => (
                  <option key={u.id} value={u.id}>
                    {u.name} {u.last_name}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="flex-shrink-0" style={{ minWidth: "150px" }}>
            <select
              className="form-control form-control-sm text-uppercase"
              onChange={handleChangeAssignedBy}
              value={selectedAssignedBy}
            >
              <option value="">Assigned By</option>
              {assigners.map((u) => (
                <option key={u.id} value={u.id}>
                  {u.name} {u.last_name}
                </option>
              ))}
            </select>
          </div>

          <div className="flex-shrink-0" style={{ minWidth: "130px" }}>
            <select onChange={handleChangeType} className="form-control form-control-sm" value={selectedStatus}>
              <option value="">Select Status</option>
              <option value="">All Status</option>
              <option value="Pending">Pending</option>
              <option value="Completed">Completed</option>
              <option value="Finished">Finished</option>
              <option value="Progress">Progress</option>
              <option value="Delayed">Delayed</option>
              <option value="Delayed Completed">Delayed Completed</option>
              <option value="ExFinished">Except Finished</option>
            </select>
          </div>

          <div className="flex-shrink-0" style={{ minWidth: "140px" }}>
            <input
              name="start_date"
              onChange={handleChangeStartDate}
              className="form-control form-control-sm"
              type="date"
              value={startDate}
            />
          </div>

          <div className="flex-shrink-0" style={{ minWidth: "140px" }}>
            <input
              name="end_date"
              onChange={handleChangeEndDate}
              className="form-control form-control-sm"
              type="date"
              value={endDate}
            />
          </div>
        </div>

        <div className="print-only-title d-none mb-2">
          <h4 className="mb-0">
            {user?.department_id === 1 ? "All Tasks List" : "Your Tasks List"} ({TaskCount})
          </h4>
          <small>
            Printed: {moment().format("DD MMM YYYY, hh:mm A")}
          </small>
        </div>

        <div className="table-responsive dashboard-tasks-table">
          {isLoading ? (
            <TaskSkeleton />
          ) : (
            <table className="table table-striped">
              <thead className="table-primary">
                <tr>
                  <th>No</th>
                  <th>Id</th>
                  <th className="text-danger">Created On</th>
                  <th>Description</th>
                  <th>Assign To</th>
                  <th>Department</th>
                  <th>Status</th>
                  <th>Due Date</th>
                  <th>W</th>
                  {user && user.company_id === 1 && <th>EH</th>}
                  <th>Priority</th>
                  <th>Assign By</th>

                  <th className="no-print">Status</th>

                  {/* Add other fields as necessary */}
                </tr>
              </thead>
              <tbody>
                {tasks.map((user, index) => (
                  <tr key={user.id}>
                    <td>{index + 1}</td>
                    <td>T{user.id}</td>
                    <td width="90px">
                      {moment(user.created_at).format("DD MMM,YY")}
                    </td>

                    <td
                      className="custom-tooltip"
                      title={user.description}
                      width="450px"
                    >
                      <b>{user.jc_id ? "JC-" + user.jc_id : ""}</b>{" "}
                      <b>{user.amc_id ? `AC-${user.amc_id}` : ""}</b>{" "}
                      {user.description}<br />
                      <span className="text-success">{user.customer_name}</span>
                    </td>

                    <td
                      className={`text-uppercase fw-bold ${user.assignee?.name && user.assignee?.last_name
                        ? "background-color-class"
                        : ""
                        }`}
                      style={{
                        color: getUniqueBackgroundColor(user.assignee?.id),
                      }}
                    >
                      {user.assignee?.name} {user.assignee?.last_name}
                      {user.task_file && (
                        <FontAwesomeIcon
                          icon={faFile}
                          className="mx-2"
                          onClick={() => downloadFile(user.task_file)}
                        />
                      )}
                    </td>
                    <td>{user.department?.name}</td>
                    <td>
                      {" "}
                      {user.status === "Completed" && (
                        <div>
                          <span className="badge bg-success font-size-13">
                            Completed at
                          </span><br />
                          <span>{moment(user.updated_at).format("DD MMM,YY hh:mm A")}</span>
                        </div>
                      )}
                      {user.status === "Pending" && (
                        <span className="badge bg-warning font-size-13">
                          Pending
                        </span>
                      )}
                      {user.status === "Delayed" && (
                        <span className="badge bg-danger font-size-13">
                          Delayed
                        </span>
                      )}
                      {user.status === "Delayed Completed" && (
                        <span className="badge bg-danger font-size-13">
                          Delayed Completed
                        </span>
                      )}

                      {user.status === "Finished" && (
                        <span className="badge bg-primary font-size-13">
                          Finished
                        </span>
                      )}

                      {user.status === "Progress" && (
                        <span className="badge bg-secondary font-size-13">
                          Progress
                        </span>
                      )}
                    </td>

                    <td width="100px">
                      {moment(user.target_date).format("DD MMM,YY")}{" "}
                      {user.is_revised == 1 && (
                        <a
                          href="#"
                          className="badge bg-danger font-size-13"
                          onClick={() =>
                            openModalRevise(
                              user.revised_remark,
                              user.revised_date
                            )
                          }
                        >
                          R
                        </a>
                      )}
                    </td>

                    <td>{user.task_weightage}</td>
                    {user && user.company_id === 1 && <td>{user.est_time}</td>}
                    <td>{user.priority}</td>
                    <td className="text-uppercase fw-bold">
                      {user.assigner?.name} {user.assigner?.last_name}
                    </td>

                    <td className="no-print">
                      {/* {(user.assigned_to ===loginUserId ? (
                                                <>
                                                    <select onChange={statusUpdate} className='form-select-sm mb-2'>
                                                        <option value="">Status</option>
                                                        <option value="Progress">Progress</option>
                                                        <option value="Completed">Completed</option>
                                                    </select>
                                                    <button className='btn-sm btn btn-link' onClick={() => handleSave(user.id)}>Save</button>
                                                    <button className='btn-sm btn btn-link' onClick={() => openModal(user.id)}>Revise</button>
                                                </>
                                        ):""
                                          )} */}
                      {loginUser === 1 ? (
                        <a
                          className="button btn-sm btn-danger"
                          onClick={() => {
                            if (
                              window.confirm(
                                "Are you sure you want to delete this task?"
                              )
                            ) {
                              deleteTask(user.id);
                            }
                          }}
                        >
                          Del
                        </a>
                      ) : (
                        ""
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <style>{`
        @media print {
          nav, .navbar, .no-print, .Toaster, [class*="toast"] {
            display: none !important;
          }
          .print-only-title {
            display: block !important;
          }
          .container, .table-responsive {
            width: 100% !important;
            max-width: 100% !important;
            overflow: visible !important;
          }
          .table {
            font-size: 10px !important;
          }
          .table th, .table td {
            padding: 4px !important;
          }
        }
      `}</style>
    </>
  );
}